const certHnmConfig = {
  name: 'cert',
  edsLoginLandingPage:
    'https://platform.cert.heinemann.com/ui/login/landing-page',
  contentShareAppUrl: 'https://platform-content-share.cert.heinemann.com/',
  contentProvider: 'https://platform.cert.heinemann.com/ui/#/contentProvider/',
  learnosityAssessementPreview:
    'https://platform.cert.heinemann.com/ui/#/assessment-view/preview',
  edsLogoutUrl: 'https://api.cert.heinemann.com/login/logout',
  rootUrl: 'https://platform.cert.heinemann.com',
  loginUrl: 'https://platform.cert.heinemann.com/ui/login/',
  loggedInUrl: 'https://platform.cert.heinemann.com/ui/logged-in/',
  loggedOutUrl: 'https://platform.cert.heinemann.com/ui/login/logged-out/',
  helpUrl: 'http://downloads.hmlt.hmco.com/Help/Flight/LogIn/',
  privacyPolicyUrl:
    'https://www.heinemann.com/privacy/?utm_medium=shorturl&utm_source=privacy',
  termsAndConditionsUrl:
    'https://www.heinemann.com/platforms-terms-of-use/?utm_medium=shorturl&utm_source=platform-terms',
  forgotPasswordUrlPath: '/ui/login/forgot-password/',
  requestSigninDetailsUrlPath: '/ui/login/request-signin-details/',
  edsPostLogoutRedirectUrl: 'https://platform.cert.heinemann.com/',
  flightRosteredLoginUrl: 'https://platform.cert.heinemann.com/ui/login/',
  edsLoginClientId: '2cc7842e-ed1b-401e-b203-c2756a26d795',
  edsLoginUrl: 'https://api.cert.heinemann.com/login/login/initializeUri',
  edsLoginIssuer: 'https://platform-cert.authorization.heinemann.com',
  edsGraphUrl: 'https://api.cert.heinemann.com/graphql',
  edsLtiUrl: 'https://api.cert.heinemann.com/lti/lti',
  edLtiUrl: 'https://api.cert.hmhco.com/lti-platform',
  rceProtocolHost: 'https://cert.hmhco.com',
  planktonBaseUrl: 'https://d16qzots3do3wk.cloudfront.net/',
  isPlanktonPreview: false,
  edsContentShareClientId: '2432c4e2-921a-460a-b938-7c44fc7d516e',
  edsContentShareInitializeUrl:
    'https://api.cert.heinemann.com/lti/lti/launch/share-link',
  edsContentShareAuthorizeUrl:
    'https://api.cert.heinemann.com/lti/lti/authorize',
  edsContentShareTokenUrl: 'https://api.cert.heinemann.com/lti/lti/token',
  restUdsApi: 'https://api.cert.hmhco.com/uds/',
  featureFlagURL:
    'https://platform.cert.heinemann.com/featureFlagsCohorts.flight.json',
  edsAuthorize: 'https://hapi.cert.hmhco.com/edcore/eds-login/login/authorize',
  heinemannBaseURL: 'https://platform.cert.heinemann.com',
  doTheMathBaseUrl: 'https://platform.cert.heinemann.com/ui/login',
  requestSigninDetails: '/ui/login/request-signin-details/',
  liftRoot: 'https://platform.cert.heinemann.com/ui/',
  jasperReporting: 'https://api.cert.heinemann.com/jasperserver-pro',
  ampLoggedInURL: 'https://cert.hmhco.com/ui/logged-in/',
  ampSignedInURL: 'https://platform.cert.heinemann.com/ui/signed-in/',
  edsInitUrl:
    'https://api.cert.heinemann.com/edcore/eds-login/login/initializeUri',
  wormhole: 'https://api.cert.hmhco.com/wh-api/graphql',
  wormholek8s: 'https://hapi.cert.hmhco.com/wormhole-api/graphql',
  apiBaseURL: 'https://cert.hmhco.com',
  restStagingProcessor: 'https://api.cert.hmhco.com/idm-staging-processor',
  flightLogin: `https://platform.cert.heinemann.com/ui/login/`,
  EDSLoginUrl: 'https://api.cert.heinemann.com/edcore/eds-login',
  edsAuthorizationCode:
    'https://api.cert.heinemann.com/edcore/eds-login/login/authorization-code/callback',
  authorizationApi: 'https://cert.hmhco.com/api/authorization',
  restIdsGridApi: 'https://api.cert.hmhco.com/ids-grid-api',
  hcpIdentityApiGateway: 'https://hapi.cert.hmhco.com/hcp-identity-api-gateway',
  susAuth: 'https://cert.hmhco.com/api/authorization',
  ampLogin: 'https://platform.cert.heinemann.com/ui/login',
  ltiCache: 'https://api.cert.hmhco.com/lti-deep-linking/cache',
  assessmentsK8: 'https://app01.cert.tsg.hmhco.com/assessment',
  onesearch: 'https://cert.hmhco.com/api/onesearch/v1',
  heinemannMarketingBaseUrl: 'https://web-delivery-v1.cert.webnp.heinemann.com',
};

module.exports = certHnmConfig;
